import {setup} from '../../snippets/node';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  price: {},
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  portal: {},
  'run-server': {
    Component: CreateShellCommand('npm start'),
  },
};
export default ({keys, merchant, client}) => `{+setup}
${comment && comment(merchant)}
const stripe = require('stripe')('${keys.secret}');
{/setup}
const express = require('express');
const app = express();
app.use(express.static('public'));
app.use(express.urlencoded({ extended: true }));
app.use(express.json());


const YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242'
}';

app.post('/create-checkout-session', async (req, res) => {
  {+price}
  const prices = await stripe.prices.list({
    lookup_keys: [req.body.lookup_key],
    expand: ['data.product'],
  });
  {/price}
  {+create}
  const {span response create}session{/span} = await stripe.checkout.sessions.create({
    billing_address_collection: 'auto',
    {+payment-methods}
    payment_method_types: ['card'],
    {/payment-methods}
    {+line-items}
    line_items: [
      {
        price: prices.data[0].id,
        // For metered billing, do not pass quantity
        quantity: 1,

      },
    ],
    {/line-items}
    {+mode}
    mode: 'subscription',
    {/mode}
    {+urls}
    success_url: \`\${YOUR_DOMAIN}${
      client === 'react'
        ? '?success=true&session_id={CHECKOUT_SESSION_ID}'
        : '/success.html?session_id={CHECKOUT_SESSION_ID}'
    }\`,
    cancel_url: \`\${YOUR_DOMAIN}${
      client === 'react' ? '?canceled=true' : '/cancel.html'
    }\`,
    {/urls}
    {?add-discount discounts}
    discounts: [{
      coupon: '{{COUPON_ID}}',
    }],
    {/discounts}
    {?add-customer customer}
    customer: 'cus_123',
    {/customer}
    {?add-trial trial-period-days}
    subscription_data: {
      trial_period_days: 7,
    },
    {/trial-period-days}
    {?automatic-tax automatic-tax-param}
    automatic_tax: { enabled: true },
    {/automatic-tax-param}
  });

  {+redirect}
  res.redirect(303, session.url);
  {/redirect}
  {/create}
});

app.post('/create-portal-session', async (req, res) => {
  // For demonstration purposes, we're using the Checkout session to retrieve the customer ID.
  // Typically this is stored alongside the authenticated user in your database.
  const { session_id } = req.body;
  const checkoutSession = await stripe.checkout.sessions.retrieve(session_id);

  {+portal}
  // This is the url to which the customer will be redirected when they are done
  // managing their billing with the portal.
  const returnUrl = YOUR_DOMAIN;

  const portalSession = await stripe.billingPortal.sessions.create({
    customer: checkoutSession.customer,
    return_url: returnUrl,
  });
  {/portal}

  {+redirect-portal}
  res.redirect(303, portalSession.url);
  {/redirect-portal}
});

{+provision-access-webhooks}
app.post(
  '/webhook',
  express.raw({ type: 'application/json' }),
  (request, response) => {
    const event = request.body;
    // Replace this endpoint secret with your endpoint's unique secret
    // If you are testing with the CLI, find the secret by running 'stripe listen'
    // If you are using an endpoint defined with the API or dashboard, look in your webhook settings
    // at https://dashboard.stripe.com/webhooks
    const endpointSecret = 'whsec_12345';
    // Only verify the event if you have an endpoint secret defined.
    // Otherwise use the basic event deserialized with JSON.parse
    if (endpointSecret) {
      // Get the signature sent by Stripe
      const signature = request.headers['stripe-signature'];
      try {
        event = stripe.webhooks.constructEvent(
          request.body,
          signature,
          endpointSecret
        );
      } catch (err) {
        console.log(\`⚠️  Webhook signature verification failed.\`, err.message);
        return response.sendStatus(400);
      }
    }
    let subscription;
    let status;
    // Handle the event
    switch (event.type) {
      case 'customer.subscription.trial_will_end':
        subscription = event.data.object;
        status = subscription.status;
        console.log(\`Subscription status is \${status}.\`);
        // Then define and call a method to handle the subscription trial ending.
        // handleSubscriptionTrialEnding(subscription);
        break;
      case 'customer.subscription.deleted':
        subscription = event.data.object;
        status = subscription.status;
        console.log(\`Subscription status is \${status}.\`);
        // Then define and call a method to handle the subscription deleted.
        // handleSubscriptionDeleted(subscriptionDeleted);
        break;
      case 'customer.subscription.created':
        subscription = event.data.object;
        status = subscription.status;
        console.log(\`Subscription status is \${status}.\`);
        // Then define and call a method to handle the subscription created.
        // handleSubscriptionCreated(subscription);
        break;
      case 'customer.subscription.updated':
        subscription = event.data.object;
        status = subscription.status;
        console.log(\`Subscription status is \${status}.\`);
        // Then define and call a method to handle the subscription update.
        // handleSubscriptionUpdated(subscription);
        break;
      default:
        // Unexpected event type
        console.log(\`Unhandled event type \${event.type}.\`);
    }
    // Return a 200 response to acknowledge receipt of the event
    response.send();
  }
);
{/provision-access-webhooks}

app.listen(4242, () => console.log('Running on port 4242'));`;
